module.exports = __webpack_public_path__ + "static/media/hall-P10.9f364b5e.svg";